import { NavLink } from 'react-router-dom';
import Table from '../Listing/Table';

const formatAmount = (val) =>
    new Intl.NumberFormat('fr-MA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val ?? 0);

const formatDate = (iso) => {
    if (!iso) return '—';
    return new Date(iso).toLocaleDateString('fr-MA', { day: '2-digit', month: 'short', year: 'numeric' });
};

const STATUS_META = {
    APPROVED: { label: 'Approuvé',   bg: '#ecfdf5', color: '#065f46', dot: '#10b981' },
    PENDING:  { label: 'En attente', bg: '#fffbeb', color: '#92400e', dot: '#f59e0b' },
    REJECTED: { label: 'Rejeté',     bg: '#fef2f2', color: '#991b1b', dot: '#ef4444' },
};

const columns = [
    {
        Header: 'Retour',
        Cell: (row) => {
            const s = STATUS_META[row._returnStatus] ?? { label: row._returnStatus, bg: '#f3f4f6', color: '#6b7280', dot: '#9ca3af' };
            return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <NavLink
                        to={`/returns/${row._returnId}`}
                        style={{ fontSize: 12, fontWeight: 700, color: '#991b1b', textTransform: 'uppercase', letterSpacing: '0.04em' }}
                    >
                        #{row._returnIndex}
                    </NavLink>
                    <span style={{ fontSize: 11, color: '#9ca3af' }}>{formatDate(row._returnDate)}</span>
                    <span style={{
                        display: 'inline-flex', alignItems: 'center', gap: 4,
                        background: s.bg, color: s.color,
                        padding: '2px 7px', borderRadius: 999, fontSize: 11, fontWeight: 600,
                        width: 'fit-content',
                    }}>
                        <span style={{ width: 5, height: 5, borderRadius: '50%', background: s.dot }} />
                        {s.label}
                    </span>
                </div>
            );
        },
    },
    {
        Header: 'Article',
        Cell: (row) => {
            const path = row.itemType?.toLowerCase() === 'product' ? `/products/${row.itemId}` : null;
            return (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    {path
                        ? <NavLink to={path} style={{ fontSize: 14, fontWeight: 600, color: '#111827', textDecoration: 'none' }}>{row.itemName}</NavLink>
                        : <span style={{ fontSize: 14, fontWeight: 600, color: '#111827' }}>{row.itemName}</span>
                    }
                </div>
            );
        },
    },
    {
        Header: 'Qté retournée',
        className: 'text-center',
        Cell: (row) => (
            <span style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                minWidth: 32, height: 26,
                background: '#fef2f2', color: '#dc2626',
                borderRadius: 8, fontSize: 13, fontWeight: 700,
                padding: '0 10px',
            }}>
                −{row.quantity}
            </span>
        ),
    },
    {
        Header: 'Prix unit.',
        className: 'text-end',
        Cell: (row) => (
            <span style={{ fontSize: 13, color: '#6b7280' }}>
                {formatAmount(row.unitPrice)} <span style={{ fontSize: 11, color: '#9ca3af' }}>dhs</span>
            </span>
        ),
    },
    {
        Header: 'Sous-total',
        className: 'text-end',
        Cell: (row) => (
            <>
                <span style={{ fontSize: 14, fontWeight: 700, color: '#dc2626' }}>
                    −{formatAmount(row.unitPrice * row.quantity)}
                </span>
                <span style={{ fontSize: 11, color: '#9ca3af', marginLeft: 3 }}>dhs</span>
            </>
        ),
    },
];

const OrderReturns = ({ returns }) => {
    if (!returns?.length) return (
        <div style={{ padding: '2rem 1.25rem', textAlign: 'center', color: '#9ca3af', fontSize: 13 }}>
            Aucun retour pour cette vente.
        </div>
    );

    const rows = returns.flatMap((ret, idx) =>
        ret.items.map((item) => ({
            ...item,
            _returnId: ret.id,
            _returnIndex: idx + 1,
            _returnDate: ret.createdAt,
            _returnStatus: ret.status,
            _returnReason: ret.reason,
        }))
    );

    return (
        <Table
            mode="client"
            columns={columns}
            data={rows}
            totalElements={rows.length}
            multiSelect={false}
            emptyMessage="Aucun retour"
            showColumnsButton={false}
            showExportButton={false}
        />
    );
};

export default OrderReturns;
